import { render, staticRenderFns } from "./CookieInformation.vue?vue&type=template&id=0fc19b5c&scoped=true&"
import script from "./CookieInformation.vue?vue&type=script&lang=js&"
export * from "./CookieInformation.vue?vue&type=script&lang=js&"
import style0 from "./CookieInformation.vue?vue&type=style&index=0&id=0fc19b5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc19b5c",
  null
  
)

export default component.exports